import React, { useContext, useEffect, useState } from 'react';

import { urls } from './api/urls';
import GridProvider from './components/GridProvider';

import TabsProvider from './components/TabsProvider';
import useHttp from '../../../../../hooks/use-http';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';
import { useTranslation } from 'react-i18next';
import { TabContext } from '../../../../../Context/TabContext';

const Dnevnik = ({ idMasine }) => {
  const { i18n } = useTranslation();
  const { getData, isLoading } = useHttp('');
  const [dnevnikArr, setdnevnikArr] = useState([]);
  const [dnevnikBazaZnanjaArr, setdnevnikBazaZnanjaArr] = useState([]);
  const [openDialogNapomena, setOpenDialogNapomena] = useState(false);
  const [napomena, setNapomena] = useState({});
  const { addTab } = useContext(TabContext);

  const handleGetDnevnik = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_IZVESTAJ_SA_TERENA,
      data: { idMasine: idMasine },
    };
    const result = await getData(config);
    setdnevnikArr(result);
    console.log(result);
  };
  const handleGetBazaZnanja = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_BAZA_ZNANJA,
      data: { idMasine: idMasine },
    };
    const result = await getData(config);
    setdnevnikBazaZnanjaArr(result);
    console.log(result);
  };

  useEffect(() => {
    handleGetDnevnik();
    handleGetBazaZnanja();
  }, [idMasine]);

  const handleClickNapomena = (item) => {
    setOpenDialogNapomena(true);
    setNapomena(item);
  };
  const handleClickBrojRn = async (item) => {
    const metadata = item.ceoBrDok.replace(/[^A-Za-z]/g, '');
    const config = {
      method: 'POST',
      url:
        metadata === 'RNPUR'
          ? urls.GET_PUSTANJE_U_RAD_ZA_ID
          : urls.GET_RN_ZA_ID,
      data: {
        idKorProm: +localStorage.getItem('idKorisnika'),
        metadata: i18n.language,
        idDok: item.idDok,
      },
    };
    const result = await getData(config);
    console.log('rezultat', result);
    if (result.length > 0) {
      if (metadata === 'RNPUR') {
        const tab = {
          title: 'Pregled puštanja mašine',
          icon: 'fas fa-clipboard',
          type: 10022,
          data: result[0],
        };
        addTab(tab);
      } else {
        const tab = {
          title: 'Radni nalog',
          icon: 'fas fa-clipboard',
          type: 10012,
          data: result[0],
        };
        addTab(tab);
      }
    }
  };
  return (
    <div>
      {/* <GridProvider
        data={dnevnikArr}
        isLoading={isLoading}
        handleClickNapomena={handleClickNapomena}
      /> */}
      <TabsProvider
        izvestajSaTerena={dnevnikArr}
        bazaZnanja={dnevnikBazaZnanjaArr}
        handleClickNapomena={handleClickNapomena}
        handleClickBrojRn={handleClickBrojRn}
      />
      <MuiDialog
        maxWidth="xl"
        open={openDialogNapomena}
        title="Napomena"
        content={
          <div>
            <div style={{ marginBottom: '10px', textDecoration: 'underline' }}>
              {napomena.imeZaposlenog} {formatDateFromDB(napomena.datum)}
            </div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{napomena.napomena}</div>
          </div>
        }
        handleClose={() => setOpenDialogNapomena(false)}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Dnevnik;
